import { useSelector } from 'react-redux'
import pluralize from 'pluralize'
import { Button } from 'reactstrap'

const Header = ({ toggleClearCartModal }) => {
  const reservationsCount = useSelector(state => state.cart.reservations.length)
  const reservationsCountText = `${reservationsCount} ${pluralize('Reservations', reservationsCount)}`

  return (
    <div className="align-items-center d-flex justify-content-between mb-3">
      <div>
        <h4>Cart</h4>

        <span className="text-muted">{reservationsCountText}</span>
      </div>

      <Button className="px-3" color="danger" onClick={toggleClearCartModal} outline>Clear Cart</Button>
    </div>
  )
}

export default Header
